import { configureStore } from '@reduxjs/toolkit';

import postReducer from './posts';
import userReducer from './user';
import uiReducer from './ui';
import buildingsReducer from './buildings';
import authReducer from './auth';
import messagesReducer from './messages';

const store = configureStore({
  reducer: {
    posts: postReducer,
    user: userReducer,
    ui: uiReducer,
    buildings: buildingsReducer,
    auth: authReducer,
    messages: messagesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
